import React from "react";

const renderTableHeader = (headers) => {
  let header = Object.keys(headers);
  return header.map((heading, index) => {
    let columnHeading = {
      retailerId: "Retailer ID",
      retailerName: "Retailer Name",
      activationCnt: "Activation Count",
    }[heading];
    return <th key={index}>{columnHeading}</th>;
  });
};

const renderTableBody = (tableBody) => {
  return tableBody.map((row, index) => {
    const { retailerId, retailerName, activationCnt } = row;
    return (
      <tr key={index}>
        <td>{retailerId}</td>
        <td>{retailerName}</td>
        <td>{activationCnt}</td>
      </tr>
    );
  });
};

export default function ActivationSalesCustomizedTables(props) {
  const { data } = props;
  const tableData = Object.values(data);

  return tableData && tableData.length ? (
    <div className="datatable" data-cy>
      <table className="table table-striped">
        <thead>
          <tr>{renderTableHeader(tableData[0])}</tr>
        </thead>
        <tbody>{renderTableBody(tableData)}</tbody>
      </table>
    </div>
  ) : (
    "NO DATA AVAILABLE"
  );
}
